import { render, staticRenderFns } from "./hotChart.vue?vue&type=template&id=b77ad2fa"
import script from "./hotChart.vue?vue&type=script&lang=js"
export * from "./hotChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b77ad2fa')) {
      api.createRecord('b77ad2fa', component.options)
    } else {
      api.reload('b77ad2fa', component.options)
    }
    module.hot.accept("./hotChart.vue?vue&type=template&id=b77ad2fa", function () {
      api.rerender('b77ad2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/hotChart.vue"
export default component.exports